import { FC } from 'react';
import css from './index.module.css';
import useUserData from '@hooks/useUserData';
import { toast } from 'sonner';
import axios from 'axios';

interface CountContainerInt {
  id: number;
  unit: 'ШТ' | 'КГ';
  style?: React.CSSProperties;
}

const CountContainer: FC<CountContainerInt> = ({ id, unit = 'ШТ', style }) => {
    const { cartData, refreshCartData } = useUserData();

    const manageProduct = (type: number, id: number) => {
        axios
          .post(
            `${import.meta.env.VITE_API_URL}/user/cart/${
              type === 0 ? "add" : "delete"
            }`,
            { cartId: id },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              },
            }
          )
          .then((_) => {
            toast.success(type === 0 ? "Добавили продукт" : "Удалили продукт");
            refreshCartData();
          })
          .catch((error) => {
            console.log(error);
          });
    };

    return (
      <div className={css.countContainer} style={style}>
        <div className={css.plus} onClick={(e) => { e.stopPropagation(); manageProduct(0, cartData.find(cart => cart.product.id === id)?.id || 0); }}>
          <i className="fi fi-rr-plus"></i>
        </div>

        <div className={css.count}>
          {cartData.find(cart => cart.product.id === id)?.count || 0} {unit === 'ШТ' ? 'ШТ' : 'КГ'}
        </div>

        <div className={css.minus} onClick={(e) => { e.stopPropagation(); manageProduct(1, cartData.find(cart => cart.product.id === id)?.id || 0); }}>
          <i className="fi fi-rr-minus"></i>
        </div>
      </div>
    );
};

export default CountContainer;